import curriculum from './curriculum'
import instructor from './instructor'
import skills from './skills'
import trainingCenter from './training-center'
import trainingProgram from './training-program'

export default [...curriculum, ...instructor, ...skills, ...trainingCenter, ...trainingProgram]
